import {createAction} from 'redux-actions';
import {
  paperlessTermsAndConditions
} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';
import config from '../../../config/config';

const PAPERLESS_TERMS_CONDITION_FULFILLED = 'PAPERLESS_TERMS_CONDITION_FULFILLED';
const PAPERLESS_TERMS_MODAL = 'PAPERLESS_TERMS_MODAL';
const PAPERLESS_TERMS_CONDITION = 'PAPERLESS_TERMS_CONDITION';

export default function paperlessSetting(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    paperless: [],
    paperlessByProductType: {},
    updatedPaperless: false,
    userInteraction: false,
    termsAndConditions: null,
  },
  { payload, type }
) {
  if (type === PAPERLESS_TERMS_CONDITION_FULFILLED) {
    return {
      ...state,
      isLoaded: true,
      isLoading: false,
      termsAndConditions:
        payload.data?.[':items'].root?.[':items'].contentfragment.elements.main.value,
    }
  } else {
      return state;
  }
}

export const getPaperlessTermsAndConditions = () => (dispatch) => {
    const action = createAction(PAPERLESS_TERMS_CONDITION)(
        callApi(`${config.url}${paperlessTermsAndConditions}`)
    );
    dispatch(action);
};

